import { createReducer } from 'services/reduxHelpers'
import { passengerTypes } from 'reduxModules/actions/PassengerActions'

/* ------------- Initial State ------------- */

export const initialState = {
  phone: null,
  firstName: null,
  lastName: null,
  bookingsIDs: [],
  blacklistIDs: [],
  bookings: [],
  isLoading: false,
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [passengerTypes.GET_PASSENGER_ATTEMPT]: () => ({
    isLoading: true,
  }),
  [passengerTypes.GET_PASSENGER_SUCCESS]: (_, { data: { phone, bookingsIDs, blacklistIDs } }) => ({
    phone,
    bookingsIDs,
    blacklistIDs,
    isLoading: false
  }),
  [passengerTypes.GET_PASSENGER_FAILURE]: () => ({
    ...initialState
  }),

  [passengerTypes.GET_PASSENGER_BOOKINGS_ATTEMPT]: () => ({
    isLoading: true,
  }),
  [passengerTypes.GET_PASSENGER_BOOKINGS_SUCCESS]: (_, { data: bookings }) => ({
    bookings,
    isLoading: false
  }),
  [passengerTypes.GET_PASSENGER_BOOKINGS_FAILURE]: () => ({
    bookings: [],
    isLoading: false
  })
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/PassengerReducer.js